import Measurer from "../Measurer";
import CameraRestraint from "oc-interaction/restraints2/CameraRestraint";
import RFAbstract from "./RFAbstract";
import {v3} from "oc-threejs/short3.js";


export default class RFHeightDragHandle extends RFAbstract {

    constructor(interactionHandler) {
        super(interactionHandler);
    }

    getRestraints() {
        // das DragHandle bewegt sich innerhalb des TuerYFits, in dem die Tür liegt, auf und ab
        // im TuerYFits sind die InterieurYFits relevant: das Draghandle wird wie ein einzelner Konstuktionsboden
        // behandelt

        const tuer = this.dragObject3d.owner.vsData;

        const fits = new Measurer(Measurer.CENTER).getHeightDragHandleYFits(tuer, this.dragObject3d.border);
        const box = tuer.element.localToSchrankBox(tuer.getElementBox(tuer.element));
        let restraints = this._mapFitsToRestraints(fits.map(fit=>({fit,element: tuer.element,box})), {restrictToElement: true});
        const brett_staerke = APP.settings.getFloat('brett_staerke');
        const yDelta = ((this.dragObject3d.border === Measurer.BOTTOM ? +1 : -1) * brett_staerke / 2) - box.min.y;
        const snapYsInElement = this._getSnapYsInElement(
            tuer.element, fits, [yDelta], y => y);

        // Der revertRestraint fängt das Draghandle ein, wenn der Drag den eigentlich erlaubten Bereich verlässt,
        // und stellt die Tür auf die vorige Größe zurück
        const oldBox = tuer.box.clone();
        this.dragObject3d.dragLock = false;
        const revertRestraint = new (class extends CameraRestraint {
            onEnter() {
                this.dragObject3d.dragLock = true;
                tuer.position.copy(oldBox.getCenter());
                tuer.size.copy(oldBox.getSize());
                APP.model.setDirty();
            }

            onLeave() {
                this.dragObject3d.dragLock = false;
            }
        })({priority: 0});

        restraints = [revertRestraint].concat(restraints).concat(snapYsInElement);

        return restraints;
    }

}
